import GenerateKeyDialog from './GenerateKeyDialog'

export default GenerateKeyDialog
